var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaypalFallbackCard = function SvgPaypalFallbackCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 31,
    viewBox: "0 0 51 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.861328,
    width: 50,
    height: 30,
    rx: 8,
    fill: "url(#paint0_linear_2994_2063)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2994_2063",
    x1: 69.6651,
    y1: -29.1458,
    x2: -1.88238,
    y2: 39.9654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB84D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE4BB"
  })))));
};
export { SvgPaypalFallbackCard as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCA1MSAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC4yNSIgeT0iMC44NjEzMjgiIHdpZHRoPSI1MCIgaGVpZ2h0PSIzMCIgcng9IjgiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcl8yOTk0XzIwNjMpIi8+CjxkZWZzPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjk5NF8yMDYzIiB4MT0iNjkuNjY1MSIgeTE9Ii0yOS4xNDU4IiB4Mj0iLTEuODgyMzgiIHkyPSIzOS45NjU0IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGRkI4NEQiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRkZFNEJCIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";